import { MaybeForm } from '../../Form/MaybeForm';
import { UseZodFormReturn } from '@repo/hooks/useZodForm';
import { ScrollArea } from '../../ui/scroll-area';

import {
  Dialog as DialogUI,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '../../ui/dialog';
import { Button } from '../Button/Button';
export interface DialogProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  form?: UseZodFormReturn;
  isOpen?: boolean;
  centered?: boolean;

  setIsOpen?: (isOpen: boolean) => void;
  trigger?: {
    label: string;
    variant?: React.ComponentProps<typeof Button>['variant'];
    size?: React.ComponentProps<typeof Button>['size'];
    icon?: string;
  };
}

export const Dialog = ({
  children,
  title,
  description,
  isOpen,
  form,
  setIsOpen,
  centered,
  trigger,
}: DialogProps) => {
  return (
    <DialogUI open={isOpen} onOpenChange={setIsOpen}>
      {trigger && (
        <DialogTrigger asChild>
          {typeof trigger === 'string' ? (
            <Button variant="secondary">{trigger}</Button>
          ) : (
            <Button
              variant={trigger.variant || 'secondary'}
              size={trigger.size || 'md'}
              icon={trigger.icon}
            >
              {trigger.label}
            </Button>
          )}
        </DialogTrigger>
      )}

      <DialogContent>
        <ScrollArea className="overflow-hidden max-h-[80vh] h-min" viewportClassName="max-h-[80vh]">
          <MaybeForm form={form}>
            {title && (
              <DialogTitle
                className={`mb-5 font-bold  ${centered ? 'text-xl sm:text-2xl text-center' : 'text-2xl sm:text-3xl'}`}
              >
                {title}
              </DialogTitle>
            )}

            <DialogDescription>{description}</DialogDescription>

            {children}
          </MaybeForm>
        </ScrollArea>
      </DialogContent>
    </DialogUI>
  );
};
